import React, { Component } from "react";
import Chart from "react-apexcharts";

export default class SDWanServices extends Component {
  constructor(props) {
    super(props);
    const colors = ["#66B4FD"];

    this.state = {
      series: [
        {
          name: "No of Records",
          data: [10, 4, 1, 2, 2],
        },
      ],
      options: {
        chart: {
          type: "bar",
          events: {
            click: function (chart, w, e) {
              // console.log(chart, w, e)
            },
          },
        },
        xaxis: {
          categories: [
            "SDWAN",
            "CGNET",
            "NEXTGEN-FIREWALL",
            "STATEFUL-FIREWALL",
            "ADC",
          ],
          title: {
            text: "No of Records", // Title for the X-axis
            style: {
              fontSize: "13px",
              fontWeight: "2rem",
            },
          },
          labels: {
            formatter: function (val) {
              return parseInt(val);
            },
            style: {
              fontSize: "0.7rem", // Increase the font size here
              fontWeight: "bold", // Optional: make the font bold
              colors: ["#000000"], // Optional: change the label color if needed
            },
          },
        },
        dataLabels: {
          enabled: true,
          style: {
            colors: ["#FFFFFF"],
            fontSize: "12px",
            fontWeight: 500,
          },
        },
        legend: {
          show: false,
        },
        colors: colors,

        plotOptions: {
          bar: {
            horizontal: true,
            columnWidth: "100%",
            borderRadius: 1,
            dataLabels: {
              position: "center",
            },
          },
        },
      },
    };
  }
  render() {
    return (
      <div>
        {this.props.message === "Data found" ? (
          <Chart
            options={this.state.options}
            series={this.state.series}
            type="bar"
            height={300}
          />
        ) : (
          <div
            style={{
              fontSize: "25px",
              fontWeight: "bold",
              textAlign: "center",
              color: "#605E5C",
            }}
          >
            {this.props.message}
          </div>
        )}
      </div>
    );
  }
}
